import { createFileRoute } from "@tanstack/react-router";

import ProcessingDetail from "@/pages/processing/ProcessingDetail";

function ProcessingDetailPage() {
  const { caseId } = Route.useParams();
  return <ProcessingDetail caseId={caseId} />;
}

export const Route = createFileRoute("/processing/$caseId")({
  component: ProcessingDetailPage,
});
